import { forwardRef, memo } from 'react';

import { ThumbsDownIcon, ThumbsUpIcon } from '@air/design-icons';

import { type WorkspaceAgentMessageFeedbackRating } from '~/components/v2/components/workspace/workspace-agent-panel/components/messages/feedback/WorkspaceAgentMessageFeedbackActions';

export const WorkspaceAgentMessageFeedbackSent = memo(
  forwardRef<HTMLSpanElement, { rating: WorkspaceAgentMessageFeedbackRating }>(
    function WorkspaceAgentMessageFeedbackSent({ rating }, ref) {
      return (
        <span
          aria-label={rating === 'up' ? 'You marked this as helpful' : 'You marked this as not helpful'}
          className="flex items-center justify-center rounded p-0.5"
          data-testid={
            rating === 'up' ? 'WORKSPACE_AGENT_MESSAGE_FEEDBACK_SENT_UP' : 'WORKSPACE_AGENT_MESSAGE_FEEDBACK_SENT_DOWN'
          }
          ref={ref}
          role="img"
          tabIndex={-1}
        >
          {rating === 'up' ? (
            <ThumbsUpIcon className="ads:text-icon-primary text-altitude-9 motion-safe:animate-pop" size="xs" />
          ) : (
            <ThumbsDownIcon className="ads:text-icon-primary text-altitude-9 motion-safe:animate-pop" size="xs" />
          )}
        </span>
      );
    },
  ),
);

WorkspaceAgentMessageFeedbackSent.displayName = 'WorkspaceAgentMessageFeedbackSent';
